import React, { PropTypes } from 'react'
import classNames from 'classnames'

const ControlledSelect = ({ options, selected, showPrice, onChange, className, isError, children }) => (
  <select
    value={(selected && selected.id) || ''}
    onChange={(evt) => { onChange(evt.target.value) }}
    className={classNames(['controlled-select', className, { 'error': isError }])}
  >
    {children}
    {options.map(o => (
      <option key={o.id} value={o.id}>
        {o.label}
        {(showPrice && o.price) ? "- $" + o.price : ""}
      </option>
    ))}
  </select>
)

ControlledSelect.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  selected: PropTypes.shape({
    id: PropTypes.number.isRequired
  }),
  showPrice: PropTypes.bool,
  isError: PropTypes.bool,
  onChange: PropTypes.func
}

export default ControlledSelect;